export enum PolicyStatus {
    QUOTE,
    PENDING,
    APPROVED,
    AWAITING_PAYMENT,
    FAILED_PAYMENT,
    REJECTED,
}
